import styledCmp from 'styled-components'

import { styled } from '@mui/material/styles';

import Checkbox from '@mui/material/Checkbox';

export const MaterialCheckbox = styled(Checkbox)(({ theme, small }) => ({
  padding: small && '4px',
  color: theme.palette.colors.subdued,
  borderRadius: 10,
  '& svg': {
    width: small && 18,
    height: small && 18,
  },
  '&:hover': {
    backgroundColor: theme.palette.colors.badgeMuted,
  },
  '&.Mui-checked': {
    color: theme.palette.blue.main,
  },
}));


export const SideItemText = styledCmp.div.attrs({
})`    
    font-family: Gilroy-Regular;
    font-size: 14px;
    font-style: normal;
    font-weight: 500;
    color: ${props => props.active ? props.theme.palette.colors.text : props.theme.palette.colors.muted};
    transition: 0.3s;
    cursor: pointer;
    user-select: none;

`;
